import { Component, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { FORMS } from '../forms';
import { FORMS as contentForms } from './forms';
import { SETTINGS as settings} from '../model';
import { BaseComponentConfig, BreadCrumbData, ComponentConfig,ConfigOptions, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { ActivatedRoute, Router } from '@angular/router';
import { NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';

@Component({
  selector: 'ubs-content',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./content.component.scss'],
})
export class ContentComponent extends BaseComponentConfig implements OnInit {
  breadCrumbs:BreadCrumbData[];
  viewIcon = '<nb-icon icon="nb-edit"></nb-icon>';
  //viewIcon = '<span class="nb-eye-outline" title="Over View" (click)="showOverView($event)"><svg><g data-name="Layer 2"><g data-name="eye"><rect width="24" height="24" opacity="0"/><path d="M21.87 11.5c-.64-1.11-4.16-6.68-10.14-6.5-5.53.14-8.73 5-9.6 6.5a1 1 0 0 0 0 1c.63 1.09 4 6.5 9.89 6.5h.25c5.53-.14 8.74-5 9.6-6.5a1 1 0 0 0 0-1zM12.22 17c-4.31.1-7.12-3.59-8-5 1-1.61 3.61-4.9 7.61-5 4.29-.11 7.11 3.59 8 5-1.03 1.61-3.61 4.9-7.61 5z"/><path d="M12 8.5a3.5 3.5 0 1 0 3.5 3.5A3.5 3.5 0 0 0 12 8.5zm0 5a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z"/></g></g></svg></span>';
  //<span [innerHTML]="viewIcon | safeHtml"></span>
  options:ConfigOptions = {
    name:"Name",
    title:"Content",
    idFieldName:"contentId",
    lookUpEndPoint:"LookupContent",
    searchResults:null,
    listForm:new OfbizList({
      fieldFormName:"FindContent",
      fieldFormLocation:"local",
      fieldFormFields:this.getFields("FindContent",FORMS),
      listFormName:"ListContentRest",
      entityName:"Content",
      listFormLocation:"component://kwikstore/widget/KwikstoreForms.xml",
      columnFields:this.getFields("ListContentRest",FORMS),
      endPoint:"listFindContent",
      emptyListMessage:"No content founds",
      viewIndex:1,
      findParameters:[
        {"noConditionFind":"Y"}
      ],
      actions:{
        position:"right",
        custom:[
          {
            name:'overView',
            title:'<i class="nb-list" title="Over View"></i>'
          }
        ],
        delete:false,
      }
    }),
    findForm:new OfbizForm({
      local:true,
      viewMode:"popover",
      formAction:"find",
      formName:"FindContent",
      entityName:"Content",
      formLocation:"component://content/widget/content/ContentForms.xml",
      target:"listFindContent",
      fields:this.getFields("FindContent",FORMS),
    }),
    addForm:new OfbizForm({
      local:true,
      formName:"EditContentRest",
      entityName:"Content",
      formLocation:"component://kwikstore/widget/KwikstoreForms.xml",
      fields:this.getFields("EditContentRest",FORMS),
      titleDescriptionField:this.getTitleDescriptionField("EditContentRest",FORMS),
      idFieldName:this.getIdFieldName("EditContentRest",FORMS),
    }),
    actions:["list","find","add","edit"],
    breadCrumbData:{
      displayPrefix:"Content",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"ListContent",
        "data":{
          "formData":{
            "formName":"ListContent",
            "formLocation":"component://content/widget/content/ContentForms.xml",
            "noConditionFind":"Y"
          },
          "endPoint":"listFindContent",
        }
      },
      addFormText:"Create Content",
      editFormText:"Update Content",
    },
    relations:[
      {
        title:"Content Attachments",
        addContainerTitle:"Add Content Attachment To",
        listContainerTitle:"Contents Attached To",
        entityName:"ContentAssoc",
        keyMap:{fieldName:"contentId"},
        addFormName:"AddContentAssoc",
        listFormName:"ListContentAssocFrom",
        addForm:new OfbizForm({
          formName:"AddContentAssoc",
          local:true,
          formLocation:"component://content/widget/content/ContentForms.xml",
          fields:this.getFields("AddContentAssoc",contentForms),
        }),
        listForm:new OfbizList({
          listFormName:"ListContentAssocFromRest",
          listFormLocation:"component://kwikstore/widget/KwikstoreForms.xml",
          columnFields:this.getFields("ListContentAssocFromRest",contentForms),
          fieldFormFields:this.getFields("AddContentAssoc",contentForms),
          emptyListMessage:"No associated content found"
        })
      },
      {
        title:"Content Roles",
        addContainerTitle:"Add Role To",
        listContainerTitle:"Content Roles For",
        entityName:"ContentRole",
        keyMap:{fieldName:"contentId"},
        addFormName:"AddContentRole",
        listFormName:"ListContentRole",
        addForm:new OfbizForm({
          formName:"AddContentRole",
          local:true,
          formLocation:"component://content/widget/content/ContentForms.xml",
          fields:this.getFields("AddContentRole",contentForms),
        }),
        listForm:new OfbizList({
          listFormName:"ListContentRole",
          listFormLocation:"component://content/widget/content/ContentForms.xml",
          columnFields:this.getFields("ListContentRole",contentForms),
          fieldFormFields:this.getFields("AddContentRole",contentForms),
          emptyListMessage:"No people linked to this content"
        })
      }
    ],
    settings:settings,
    summaryView:[//Content,Association,Roles,ContentPurpose,Attribute,WebSites,MetaData,WorkEffort,Keywords
      {
        title:"Edit Content",
        order:1,
        type:"single",
        formName:"EditContent",
        entityName:"Content",
        formLocation:"component://content/widget/content/ContentForms.xml",
        fullWidth:false
      },
      {
        title:"Associations",
        entityName:"ContentAssoc",
        order:2,
        type:"list",
        formName:"ListContentAssocFrom",
        formLocation:"component://content/widget/content/ContentForms.xml",
        target:"listFindContentAssocFrom",
        fullWidth:false
      },
      {
        title:"Roles",
        entityName:"ContentRole",
        order:3,
        type:"list",
        formName:"ListContentRole",
        formLocation:"component://content/widget/content/ContentForms.xml",
        target:"listFindContentRole",
        fullWidth:false
      },
      {
        title:"Attributes",
        entityName:"ContentAttribute",
        order:4,
        type:"list",
        formName:"ListContentAttribute",
        formLocation:"component://content/widget/content/ContentForms.xml",
        target:"listFindContentAttribute",
        fullWidth:false
      },
      {
        title:"Purposes",
        entityName:"ContentPurpose",
        order:5,
        type:"list",
        formName:"ListContentPurpose",
        formLocation:"component://content/widget/content/ContentForms.xml",
        target:"listFindContentPurpose",
        fullWidth:false
      },
      {
        title:"Web Sites",
        entityName:"WebSiteContent",
        order:6,
        type:"list",
        formName:"ListWebSiteContent",
        formLocation:"component://commonforms/widget/CommonFormsForms.xml",
        target:"listFindWebSiteContent",
        fullWidth:false
      },
      {
        title:"Meta Data",
        entityName:"ContentMetaData",
        order:7,
        type:"list",
        formName:"ListContentMetaData",
        formLocation:"component://content/widget/content/ContentForms.xml",
        target:"listFindContentMetaData",
        fullWidth:false
      },
    ],
    lookups:[
      {
        fieldFormName:"LookupContent",
        findFormName:"FindContent",
        resultListName:"ListContentRest",

      }
    ]
  };
  constructor(viewContainerService:ViewContainersService,
    menuService:NbMenuService,
    route:ActivatedRoute,
    router:Router,
    updateComponentStoreService:UpdateComponentStoreService,
    configurationService:ConfigurationService) {
    super(viewContainerService,menuService,configurationService,route,router,updateComponentStoreService)
    this.componentConfig = new ComponentConfig(this.options);
    //console.log({TrackComponentConfig:this.componentConfig});
    //this.cmsStore.updateComponentConfig(this.componentConfig);
   }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
  }

  

}
